import React from 'react'
import LeftSideBar from '../../components/LeftSideBar';
import Title from '../../components/Title';

export const PublicLimitedCompany = () => {
    return (
        <div className='services_main_wrapper'>
            <div className='container'>
                <div className='row mt-5 mb-5'>
                    <div className='col-md-3'>
                        <LeftSideBar />
                    </div>
                    <div className='col-md-9'>
                        <div className='right_side_content'>
                            <div className='section_main_title d-flex align-items-center justify-content-between'>
                                <div className='title_and_icon d-flex align-items-center'>
                                    <img src='/images/public_icon.jpg'></img>
                                    <Title text="Public Limited Company" className="custom-heading" />
                                </div>
                            </div>
                            <div className='discriptions'>
                                <p>A Public Limited Company (PLC) offers numerous advantages, including the ability to raise capital from the public through share issuance. This structure is ideal for businesses aiming for significant growth and expansion. At Vanani & Associates, we provide comprehensive services to help you establish and manage your Public Limited Company efficiently. Our expertise ensures that you can focus on scaling your business while we handle the legal and compliance aspects.</p>
                            </div>
                            <div className='number_list_wrap'>
                                <h4 className='mt-3 mb-2'>What is a Public Limited Company?</h4>
                                <p>A Public Limited Company (PLC) is a separate legal entity formed voluntarily by its members and registered under the Companies Act, 2013. It allows its shares to be traded publicly, offering benefits such as limited liability, ease of share transfer, and increased transparency. PLCs must adhere to government rules and policies and are governed by the provisions of the Companies Act.</p>
                            </div>

                            <div className="categories_wrapper">
                                <h4 className='font-weight-600 mb-3'><sapn className="key_features">Categories</sapn> of Public Limited Companies</h4>
                                <div className="category_cards">
                                    <div className="card maharatna">
                                        <div className="icon">👑</div>
                                        <h3>Maharatna</h3>
                                    </div>
                                    <div className="card navratna">
                                        <div className="icon">🔷</div>
                                        <h3>Navratna</h3>
                                    </div>
                                    <div className="card miniratna">
                                        <div className="icon">💰</div>
                                        <h3>Miniratna</h3>
                                    </div>
                                </div>
                            </div>

                            <div className='check_list_wrap mt-2 icon_img'>
                                <ul className='row'>
                                    <h4 className='mt-3 mb-3 font-weight-600'><sapn className="key_features">Why Choose</sapn> a Public Limited Company?</h4>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/compliant.png' width="55"></img>
                                                <p><strong>Access to Capital</strong>PLCs can raise large amounts of capital by issuing shares to the public, facilitating expansion and growth.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/registration.png' width="55"></img>
                                                <p><strong>Limited Liability</strong>Shareholders' liability is limited to their capital contribution, protecting personal assets from business liabilities.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/Simplicity.png' width="55"></img>
                                                <p><strong>Separate Legal Entity</strong>A PLC is a distinct legal entity from its shareholders, offering greater credibility and continuity.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6 mb-3'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/lower-taxes.png' width="55"></img>
                                                <p><strong>Enhanced Credibility</strong>Being publicly listed enhances the company's credibility and trust among investors, customers, and partners.</p>
                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/completed-control.png' width="55"></img>
                                                <p><strong>Ease of Share Transfer</strong>Shares can be easily transferred, providing liquidity to shareholders.</p>                                            </div>
                                        </li>
                                    </div>
                                    <div className='col-md-6'>
                                        <li>
                                            <div className='d-flex align-items-start gap-3 p-3'>
                                                <img src='images/reduction.png' width="55"></img>
                                                <p><strong>Unlimited Members</strong>There is no limit on the number of shareholders in a PLC, enabling broad ownership and participation.</p>
                                            </div>
                                        </li>
                                    </div>
                                </ul>
                            </div>

                            <div className='row mt-2 pulic_limited_advantages'>
                                <div className='col-md-7'>
                                    <div className='check_list_wrap mt-2'>
                                        <h4 className='mb-3'><sapn className="key_features">Advantages</sapn> of Public Limited Company Registratio</h4>
                                        <ul className='mb-0'>
                                            <li><strong>Raising Capital:</strong>Ability to issue shares and raise significant capital from the public and institutional investors.</li>
                                            <li><strong>Liquidity:  </strong>Shares of a PLC can be freely transferred and traded on stock exchanges, providing liquidity to shareholders.</li>
                                            <li><strong>Growth Potential:  </strong>Access to substantial capital allows for large-scale expansion and growth.</li>
                                            <li><strong>Increased Trust:  </strong>Public listing enhances the company's reputation and trust among stakeholders.</li>
                                            <li><strong>Professional Management:  </strong>PLCs often benefit from a structured management team and board of directors.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className='col-md-5'>
                                    <div className='box_shadow mb-4'>
                                        <img className='img_width' src='/images/public_bnr_img.jpg' alt='Partnership Firm'></img>
                                    </div>
                                </div>
                            </div>

                            <div className="number_list_wrap essential_points">
                                <h4 className="mb-4 font-weight-600">Essential Points for <sapn className="key_features">Public Limited Company Registration</sapn></h4>
                                <div className="feature-list">
                                    <div className="feature-item">
                                        <div className="icon-box">📋</div>
                                        <div className="feature-content">
                                            <h5>Minimum Requirements</h5>
                                            <ul>
                                                <li><b>Directors:</b> At least 3 Directors</li>
                                                <li><b>Shareholders:</b> At least 7 Shareholders</li>
                                                <li><b>Authorized Capital:</b> Minimum ₹5,00,000</li>
                                                <li><b>Company Name:</b> Must include “Public Limited Company”</li>
                                                <li><b>Registered Office:</b> Must be located in India</li>
                                            </ul>
                                        </div>
                                    </div>

                                    <div className="feature-item">
                                        <div className="icon-box">💳</div>
                                        <div className="feature-content">
                                            <h5>Digital Signature Certificate (DSC)</h5>
                                            <ul>
                                                <li><b>Bank Account:</b> Open a business account in company’s name</li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>
                            </div>


                            <div className="number_list_wrap key_eatures_opc">
                                <h4 className="section_title font-weight-600"><sapn className="key_features">Steps</sapn> for Company Registration in India</h4>
                                <div className="row">
                                    <div className="col-md-12">
                                        <ol className="feature_list">
                                            <li>
                                                <span className="feature_number">1</span>
                                                <div className="feature_content">
                                                    <strong>RUN Name Approval:</strong> Reserve a unique name for your company by submitting a request to the Ministry of Corporate Affairs (MCA). Our professionals assist you in selecting the perfect name and registering it with the government.
                                                </div>
                                            </li>
                                            <li>
                                                <span className="feature_number">2</span>
                                                <div className="feature_content">
                                                    <strong>Get Directors’ Digital Signature Certificate (DSC):</strong> Digital signatures are required for all filings with the MCA. We help directors obtain a DSC from a recognized certifying body.
                                                </div>
                                            </li>
                                            <li>
                                                <span className="feature_number">3</span>
                                                <div className="feature_content">
                                                    <strong>Submit the Company Incorporation Application:</strong> After obtaining the required digital signatures, we submit the company incorporation application in the SPICe form along with all necessary documents to the MCA. The application includes the Memorandum of Association (MOA) and Articles of Association (AOA). Upon review and acceptance, the MCA issues an incorporation certificate and PAN for the company.
                                                </div>
                                            </li>
                                            <li>
                                                <span className="feature_number">4</span>
                                                <div className="feature_content">
                                                    <strong>Issue of Prospectus:</strong> Prepare and file a prospectus with the Registrar of Companies (RoC) before offering shares to the public.
                                                </div>
                                            </li>
                                        </ol>
                                    </div>
                                </div>
                            </div>

                            <div className="numbered-documents row mt-4">
                                <h4 className='mt-4 mb-4 font-weight-600'><sapn className="key_features">Documents Required</sapn> for Public Limited Company Registration</h4>
                                <div className="col-md-4">
                                    <div className="doc-box">
                                        <div className="doc-circle">1</div>
                                        <h5><b>Directors' Documents:</b></h5>
                                        <ul>
                                            <li>One passport-sized photograph of each director.</li>
                                            <li>Self-attested PAN card copy of each director.</li>
                                            <li>Self-attested proof of identity (Voter ID, Passport, Driving License, Aadhaar Card) for each director.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="doc-box box_height_1">
                                        <div className="doc-circle">2</div>
                                        <h5><b>Business Address Proof:</b></h5>
                                        <ul className='mt-2'>
                                            <li>Any one of the following: Electricity Bill, Telephone Bill, Property Tax Bill, Gas Bil</li>
                                            <li>If rented: Rent agreement copy.</li>
                                            <li>If owned: Sale deed.</li>
                                        </ul>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="doc-box box_height_1">
                                        <div className="doc-circle">3</div>
                                        <h5><b>Company Information:</b></h5>
                                        <ul className='mt-2'>
                                            <li>Proposed company name.</li>
                                            <li>Description of the company’s services, objects, or products.</li>
                                        </ul>
                                    </div>
                                </div>
                            </div>

                            <div className="check_list_wrap mt-2 compliance_checklist_flow">
                                <h4 className="mt-4 mb-2 font-weight-600">Public Limited Company <sapn className="key_features">Compliance</sapn></h4>
                                <p>
                                    Maintaining compliance is crucial for a registered public limited company in India. After registration, a company must comply with requirements such as:
                                </p>

                                <div className="checklist-flow">
                                    <div className="checklist-item">
                                        <span className="check-icon">✅</span>
                                        <div className="check-content">
                                            <strong>Appoint a Chartered Accountant:</strong>Within 30 days of incorporation, appoint a certified Chartered Accountant and file the annual income tax return using form ITR-6.
                                        </div>
                                    </div>

                                    <div className="checklist-item">
                                        <span className="check-icon">📧</span>
                                        <div className="check-content">
                                            <strong>Annual Identity Verification: </strong>Submit DIN KYC to verify the phone number and email address on file with the MCA each year.
                                        </div>
                                    </div>

                                    <div className="checklist-item">
                                        <span className="check-icon">🏦</span>
                                        <div className="check-content">
                                            <strong>Deposit Subscription and Create a Bank Account: </strong>Shareholders must deposit the subscription amount within 180 days of incorporation and create a bank account for the company.
                                        </div>
                                    </div>

                                    <div className="checklist-item">
                                        <span className="check-icon">📁</span>
                                        <div className="check-content">
                                            <strong>MCA Annual Filings: </strong>File annual returns and financial statements each financial year, including Forms MGT-7 and AOC-4.
                                        </div>
                                    </div>

                                    <div className="checklist-item">
                                        <span className="check-icon">🧾</span>
                                        <div className="check-content">
                                            <strong>Income Tax Filing: </strong>File the company’s income tax return using form ITR-6 each financial year.
                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default PublicLimitedCompany;
